export enum StyledInputTypes {
  PASSWORD = 'password',
  EMAIL = 'email',
  TEXT = 'text'
}
